<template>
  <div></div>
</template>
<script>

export default {
  components: {},
  name: 'Tour',
  methods: {
    start: function (skipIfAlreadySeen = false) {
      switch (this.$route.name) {
        case 'Dashboard':
          if (this.$route.meta.empty === true) {
            this.$hlp.startTour(process.env.HLP_TOUR_DASHBOARD_EMPTY, { skipIfAlreadySeen })
          } else {
            this.$hlp.startTour(process.env.HLP_TOUR_DASHBOARD, { skipIfAlreadySeen })
          }
          break
        case 'ProjectDetails':
          switch (this.$route.meta.workflow_id) {
            case 1:
              this.$hlp.startTour(process.env.HLP_TOUR_PROJECT_DETAILS_1, { skipIfAlreadySeen })
              break
            case 2:
              this.$hlp.startTour(process.env.HLP_TOUR_PROJECT_DETAILS_2, { skipIfAlreadySeen })
              break
            case 3:
              this.$hlp.startTour(process.env.HLP_TOUR_PROJECT_DETAILS_3, { skipIfAlreadySeen })
              break
          }
          break
        case 'SearchSimple':
          if (this.$route.meta.empty === true) {
            if (this.$user.isSe()) {
              this.$hlp.startTour(process.env.HLP_TOUR_SIMPLE_SEARCH_LEA_EMPTY, { skipIfAlreadySeen })
            } else {
              this.$hlp.startTour(process.env.HLP_TOUR_SIMPLE_SEARCH_EMPTY, { skipIfAlreadySeen })
            }
          } else {
            this.$hlp.startTour(process.env.HLP_TOUR_SIMPLE_SEARCH, { skipIfAlreadySeen })
          }
          break
        case 'Search':
          let action = typeof this.$route.query.action !== 'undefined' ? this.$route.query.action : null
          let stepId = null
          if (action !== null) {
            switch (action) {
              case 'search':
                stepId = 'cjxvt7b4801ug3r5huu1jkq79'
                break
              case 'experts':
                stepId = 'cjxvt7b4801ug3r5huu1jkq79'
                break
              case 'monitor':
                stepId = 'ckwp2yhvb019j2y5rwg8eaafb'
                break
            }
          }
          if (this.$route.meta.empty === true) {
            this.$hlp.startTour(process.env.HLP_TOUR_SEARCH_EMPTY, { skipIfAlreadySeen })
          } else {
            if (stepId !== null) {
              this.$hlp.startTour(process.env.HLP_TOUR_SEARCH, { skipIfAlreadySeen: false, stepId })
            } else {
              this.$hlp.startTour(process.env.HLP_TOUR_SEARCH, { skipIfAlreadySeen})
            }
          }
          break
      }
    }
  },
  beforeMount () {
    this.$eventHub.$on('startTour', (skipIfAlreadySeen) => {
      this.start(skipIfAlreadySeen)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tour/Tour.vue